import React from 'react'
import { useEffect, useState, useCallback } from 'react';
import '../App.css';
import '../Assets/css/Main.css'
import { Col, Row, Button, Label, Input, Modal, ModalBody, ModalHeader, FormGroup, ModalFooter } from 'reactstrap';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import base from '../Services/BaseService'
import LoadSpinner from './Shared/Loading'
import { useMsal } from "@azure/msal-react";
import { loginRequest } from '../authconfig';

const CategoryModal = ({ id, closeModal, showModalForm, setSaveItem }) => {

    const [pName, setPName] = useState("")
    const [cName, setCName] = useState("")
    const [eName, setEName] = useState("")
    const [loading, setLoading] = useState(false)
    const [showModal, setShowModal] = useState(showModalForm)
    const { instance, accounts } = useMsal();
    const data = {};

    const toggleModal = () => {
        closeModal()
        setShowModal(showModal => !showModal);
    }


    const updateBudget = () => {
        if (cName === "" || eName === "" || pName === "") {
            return;
        }
        data.categoryId = pName;
        data.categoryDescription = cName;
        data.defaultAmount = eName;
        if (id === 0) {
            base.add("Category/add", data).then(() => {
                toggleModal()
                setSaveItem(new Date().getTime());
            })
        }
        else {
            base.update(`Category/${id}`, data).then(() => {
                toggleModal()
                setSaveItem(new Date().getTime());
            })
        }
    }

    const deleteBudget = () => {
        data.categoryId = pName;
        data.categoryDescription = cName;
        data.defaultAmount = eName;
        base.update(`Category/del/${id}`, "").then(() => {
            toggleModal()
            setSaveItem(new Date().getTime());
        })
    }

    const handleChange = (e) => {
        if (e.target.name === 'category') {
            setPName(e.target.value);
        }
        if (e.target.name === 'cat_Desc') {
            setCName(e.target.value)
        }
        if (e.target.name === 'defaultAmount') {
            setEName(e.target.value)
        }

        document.getElementById(e.target.id).style.border = '1px solid #cecece';
    }

    const tokenRefresh = useCallback(async () => {
        await instance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0]
        }).then((response) => {
            sessionStorage.setItem("upn", accounts[0].idTokenClaims.upn);
            sessionStorage.setItem("username", accounts[0].idTokenClaims.name);
            sessionStorage.setItem("authheader", `Bearer ${response.idToken}`);
        }).catch(() => {
            console.log("Error acquiring token")
        }
        );
    }, [accounts, instance])

    useEffect(() => {
        const getBudgetItem = () => {
            tokenRefresh()
            if (id !== 0) {
                base.getAll(`Category/${id}`).then((res) => {
                    setPName(res.categoryId);
                    setCName(res.categoryDescription);
                    setEName(res.defaultAmount);
                })
            }
            setLoading(false)
        }
        getBudgetItem()
    }, [tokenRefresh, id])


    return (
        <>
            <Modal isOpen={showModal} size="lg" toggle={toggleModal} backdrop="static">
                <ModalHeader className="bg-modal" toggle={toggleModal}><div className="page-header">{id === 0 ? "Create" : "Edit"} Category</div></ModalHeader>
                {loading ?
                    <LoadSpinner />
                    :
                    <>
                        <ModalBody>
                            <FormGroup>
                                <Row className="mb-2 align-items-center">
                                    <Col md="3" lg="2">
                                        <Label className="label-text" >Category*</Label>
                                    </Col>
                                    <Col md="9" lg="10">
                                        <Input disabled={id !== 0} type="text" className="input-text" name="category" id="category" placeholder="" defaultValue={pName} onChange={handleChange} />
                                    </Col>
                                </Row>
                                <Row className="mb-2 align-items-center">
                                    <Col md="3" lg="2">
                                        <Label className="label-text">Description*</Label>
                                    </Col>
                                    <Col md="9" lg="10">
                                        <Input type="text" className="input-text" name="cat_Desc" id="cat_Desc" placeholder="" defaultValue={cName} onChange={handleChange} />
                                    </Col>
                                </Row>
                                <Row className="mb-2 align-items-center">
                                    <Col md="3" lg="2">
                                        <Label className="label-text">Default Amount*</Label>
                                    </Col>
                                    <Col md="9" lg="10">
                                        <Input type="text" className="input-text" name="defaultAmount" id="defaultAmount" placeholder="" defaultValue={eName} onChange={handleChange} />
                                    </Col>
                                </Row>
                            </FormGroup>
                        </ModalBody>
                        <ModalFooter>
                            {id !== 0 &&
                                <>
                                    <Button color="danger" size="sm" className="btn-text b-width" onClick={() => deleteBudget()}>Delete</Button>
                                </>
                            }
                            <Button color="secondary" size="sm" className="btn-text b-width" onClick={toggleModal}>Cancel</Button>
                            <Button color="success" size="sm" className="btn-text b-width" onClick={() => updateBudget()}>Save</Button>

                        </ModalFooter>
                    </>
                }
            </Modal>
        </>
    )
}

export default CategoryModal
